import React from "react";

import { TrashIcon } from "@/components/icons-lib";

interface ConnectedSchoolRemoveButtonProps {
  canRemove: boolean;
  ariaLabel: string;
  onRemove: () => void;
}

export const ConnectedSchoolRemoveButton: React.FC<ConnectedSchoolRemoveButtonProps> = ({
  canRemove,
  ariaLabel,
  onRemove,
}) => (
  <div className="flex h-6 w-6 shrink-0 items-center justify-center">
    {canRemove ? (
      <button
        aria-label={ariaLabel}
        className="pointer-events-none invisible flex h-6 w-6 items-center justify-center rounded-lg text-red-9 hover:bg-gray-100 hover:text-red-9 focus-visible:pointer-events-auto focus-visible:visible group-focus-within:pointer-events-auto group-focus-within:visible group-hover:pointer-events-auto group-hover:visible"
        type="button"
        onClick={onRemove}
      >
        <TrashIcon className="h-5 w-5" />
      </button>
    ) : null}
  </div>
);
